/*
 * Dolgum — trust signal next to the checkout button (cart page + cart drawer).
 * Adds a small "secure checkout" line with a lock icon and the payment
 * methods Shopify Checkout actually supports for this store. No logos are
 * pulled in (avoids using card-network trademarks without a license) —
 * just plain text naming the real, supported methods, plus the genuinely
 * true fact that Shopify's checkout is SSL/TLS encrypted.
 * Additive/non-destructive: only ever appends a new element after the
 * existing checkout button(s), never edits them.
 */
(function () {
  var ACCENT = 'rgb(var(--color-button))';

  function injectStyle(css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  injectStyle(
    '.eai4-trust{display:flex;flex-direction:column;align-items:center;gap:.3rem;' +
    'margin-top:.6rem;font-family:var(--font-body-family);text-align:center;}' +
    '.eai4-trust__lock{display:inline-flex;align-items:center;gap:.4rem;font-size:.92rem;' +
    'font-weight:600;color:#374151;}' +
    '.eai4-trust__lock svg{flex-shrink:0;}' +
    '.eai4-trust__methods{font-size:.82rem;color:#6b7280;}'
  );

  function buildBadge() {
    var badge = document.createElement('div');
    badge.className = 'eai4-trust eai4-pop';
    badge.innerHTML =
      '<span class="eai4-trust__lock">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<rect x="4" y="11" width="16" height="10" rx="2" stroke="' + 'currentColor' + '" stroke-width="2"/>' +
          '<path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" stroke-width="2"/>' +
        '</svg>' +
        'Secure Checkout — SSL Encrypted' +
      '</span>' +
      '<span class="eai4-trust__methods">Visa · Mastercard · Amex · PayPal · Google Pay</span>';
    return badge;
  }

  function render() {
    var buttons = document.querySelectorAll(
      'button[name="checkout"], a[name="checkout"], input[name="checkout"]'
    );
    buttons.forEach(function (btn) {
      if (btn.dataset.eaiTrustDone === '1') return;
      var target = btn.closest('.cart__checkout-buttons, .cart__ctas') || btn;
      if (target.parentElement && target.parentElement.querySelector(':scope > .eai4-trust')) {
        btn.dataset.eaiTrustDone = '1';
        return;
      }
      btn.dataset.eaiTrustDone = '1';
      target.insertAdjacentElement('afterend', buildBadge());
    });
  }

  render();
  var mo = new MutationObserver(render);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
